import { ScriptHTMLAttributes, useEffect, useRef } from 'react';

import { useCookieConsent } from './hooks';

type ScriptProps = ScriptHTMLAttributes<HTMLScriptElement> & {
  service: string;
};

const InlineScript = ({ service, src, children }: ScriptProps) => {
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  const { isEnabled } = useCookieConsent();

  useEffect(() => {
    const anchor = anchorRef.current;

    if (isEnabled(service) && !scriptRef.current) {
      const script = document.createElement('script');
      script.type = 'application/javascript';

      if (src) {
        script.src = src;
      }

      if (children) {
        script.innerHTML = children.toString();
      }

      anchorRef.current?.appendChild(script);
      scriptRef.current = script;
    }

    return () => {
      if (!isEnabled(service) && scriptRef.current) {
        anchor?.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled]);

  return <div ref={anchorRef} />;
};

export default InlineScript;
